import { createGuard, nullable } from '@24i/nxg-core-utils/src/guards';
import * as t from 'io-ts';

export const PrimetimeGuard = createGuard('Primetime', {
    code: t.string,
    expires: t.number,
});

export const AuthPrimetimeGuard = createGuard('AuthPrimetime', {
    mvpd: t.string,
    userId: t.string,
    authenticated: t.number,
});

export const CheckAuthPrimetimeGuard = createGuard('CheckAuthPrimetime', {
    message: nullable(t.string),
    token: nullable(t.string),
    expires: nullable(t.number),
});

export type Primetime = t.TypeOf<typeof PrimetimeGuard>;
export type AuthPrimetime = t.TypeOf<typeof AuthPrimetimeGuard>;
export type CheckAuthPrimetime = t.TypeOf<typeof CheckAuthPrimetimeGuard>;
